import { useState } from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";

import createPromoCode from "@app/services/promoCodes/createPromoCode";

import { useToast } from "@hooks/useToast";

import { APPLICATION_TYPE } from "@utils/enum";

export const useCreateCoupon = () => {
  const history = useHistory();
  const { messages } = useIntl();
  const { showSuccessToast, showErrorToast } = useToast();

  const [isCancelDialogVisible, setIsCancelDialogVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenCancelDialog = () => {
    setIsCancelDialogVisible(true);
  };

  const handleCloseCancelDialog = () => {
    setIsCancelDialogVisible(false);
  };

  const createCoupon = async payload => {
    try {
      setIsLoading(true);

      await createPromoCode(payload);

      showSuccessToast(messages.message_coupon_created);

      handleCancelCouponCreation();
    } catch (error) {
      showErrorToast(messages.exception_error_message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreateCoupon = ({ products, ...values }) => {
    const allProducts =
      values.application_type === APPLICATION_TYPE.ENTIRE_ORDER;

    const payload = {
      ...values,
      all_products: allProducts,
      active: 1,
    };

    payload.products = allProducts ? [] : products?.map(({ code }) => code);

    createCoupon(payload);
  };

  const handleCancelCouponCreation = () => {
    history.goBack();
  };

  const headerConfig = {
    title: messages.title_create_coupon,
  };

  return {
    headerConfig,
    isCancelDialogVisible,
    isLoading,
    handleCreateCoupon,
    handleOpenCancelDialog,
    handleCloseCancelDialog,
    handleCancelCouponCreation,
  };
};
